import { css, keyframes, type SerializedStyles } from '@emotion/react';

export const fadeUp = keyframes`
	from {
		opacity: 0;
		transform: translateY(20px);
	}

	to {
		opacity: 1;
		transform: none;
	}
`;

export const softPulse = keyframes`
	0%, 100% {
		opacity: 1;
		transform: scale(1);
	}

	50% {
		opacity: 0.45;
		transform: scale(0.82);
	}
`;

export const spin = keyframes`
	to {
		transform: rotate(360deg);
	}
`;

export const sweep = keyframes`
	from {
		transform: translateX(-70%);
	}

	to {
		transform: translateX(270%);
	}
`;

/** Entrance animation for a block; motion is dropped when the visitor asks for reduced motion. */
export function reveal(delayInSeconds: number): SerializedStyles {
	return css`
		animation: ${fadeUp} 0.75s cubic-bezier(0.22, 0.7, 0.28, 1) both;
		animation-delay: ${delayInSeconds}s;

		@media (prefers-reduced-motion: reduce) {
			animation: none;
		}
	`;
}
